import { render, staticRenderFns } from "./Exclude.vue?vue&type=template&id=b67fd630&scoped=true"
import script from "./Exclude.vue?vue&type=script&lang=js"
export * from "./Exclude.vue?vue&type=script&lang=js"
import style0 from "./Exclude.vue?vue&type=style&index=0&id=b67fd630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67fd630",
  null
  
)

export default component.exports